
(() => {
  const HANDLE = "paperclip-multi-name-bracelet";
  const NAMES = ["First Name", "Second Name", "Third Name"];

  let scheduled = false;

  function updateFields() {
    const picker = document.querySelector(
      `variant-picker[handle="${HANDLE}"]`
    );

    if (!picker) return;

    const container = picker.closest(".product-info");
    if (!container) return;

    const groups = [
      ...picker.querySelectorAll(".variant-picker__option")
    ];

    const namesGroup = groups.find((group) => {
      const legend = group.querySelector("legend");
      return /number of names|número de nomes/i.test(
        legend?.textContent || ""
      );
    });

    if (!namesGroup) return;

    const selectedText = namesGroup.querySelector(
      ".variant-picker__option-info span"
    )?.textContent?.trim();

    const count = Number.parseInt(selectedText, 10);

    if (![1, 2, 3].includes(count)) return;

    NAMES.forEach((name, index) => {
      const wrapper = [
        ...container.querySelectorAll(
          "[data-personalization-field]"
        )
      ].find(
        (element) =>
        element.dataset.personalizationField
  ?.trim()
  .replace(/^Your\s+/i, "")
  .toLowerCase() === name.toLowerCase()
      );

      if (!wrapper) return;

      const input = wrapper.querySelector("input, textarea");
      if (!input) return;

      const visible = index < count;

      if (wrapper.hidden !== !visible) {
        wrapper.hidden = !visible;
      }

      const display = visible ? "" : "none";

      if (wrapper.style.display !== display) {
        wrapper.style.display = display;
      }

      if (input.required !== visible) {
        input.required = visible;
      }

      if (input.disabled !== !visible) {
        input.disabled = !visible;
      }

      if (!visible && input.value !== "") {
        input.value = "";
        input.dispatchEvent(
          new Event("input", { bubbles: true })
        );
      }
    });
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      updateFields();
    });
  }

  function start() {
    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["aria-checked", "checked"]
    });

    document.addEventListener(
      "change",
      scheduleUpdate,
      true
    );

    document.addEventListener(
      "click",
      scheduleUpdate,
      true
    );

    updateFields();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, {
      once: true
    });
  } else {
    start();
  }
})();
